module.exports = __webpack_public_path__ + "media/src/images/arrow_right_disabled-e742ff16f2179373c64e33b764f4d1cd.png";